import { BMText } from "@traveloka/district-bloom";
import { memo } from "react";
import { Image } from "react-native";
import BMView from "../../../../components/View/BMView";

const AIRLINES_LOGO_SIZE = 16;

type Props = { logos: { src: string; alt: string }[] };
const FlightAirlineLogos = memo(function FlightAirlineLogos({ logos }: Props) {
  const firstTwo = logos.slice(0, 2);
  const extraCount = Math.max(0, logos.length - 2);

  return (
    <BMView spacing="xs" align="center">
      <BMView row spacing="xs" justify="center">
        {firstTwo.map((item) => (
          <Image
            key={item.src}
            source={{
              uri: item.src,
              width: AIRLINES_LOGO_SIZE,
              height: AIRLINES_LOGO_SIZE,
            }}
            resizeMode="contain"
          />
        ))}
      </BMView>
      {extraCount > 0 && (
        <BMText variant="uiSmall" ink="BMStyleTextInkSecondary">
          +{extraCount}
        </BMText>
      )}
    </BMView>
  );
});

export default FlightAirlineLogos;
